export default {"src":"/_next/static/media/mana18.0f2113d8.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};